// Setup › KPI reporting at `/c/{slug}/setup/kpi-reporting` (AGENT-REPORTING; `kpi`, managers).
// The seat is in the URL (`?seat=`), so the DE profile's "KPI reporting" link and a reload open
// the same seat. With the add-on off the page says "not enabled" before any query.
import { createRoute, useNavigate } from "@tanstack/react-router";
import { isManager } from "../features/company";
import { KpiReportingScreen } from "../features/reporting/kpi-reporting-screen";
import { useCompany, useFeature } from "../features/use-feature";
import { validateFocusSearch } from "../focus/focus";
import { NoAccessPage, NotEnabledPage } from "../pages/status-pages";
import { setupRoute } from "./c.$slug.setup";

const ID = /^[0-9a-f-]{36}$/i;

export const setupKpiReportingRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "kpi-reporting",
  validateSearch: (search: Record<string, unknown>) => ({
    ...validateFocusSearch(search),
    ...(typeof search.seat === "string" && ID.test(search.seat) ? { seat: search.seat } : {}),
  }),
  component: function KpiReporting() {
    const { api } = setupKpiReportingRoute.useRouteContext();
    const { seat } = setupKpiReportingRoute.useSearch();
    const company = useCompany();
    const kpi = useFeature("kpi");
    const navigate = useNavigate();
    if (!kpi.enabled)
      return (
        <NotEnabledPage
          what="KPI reporting"
          feature="kpi"
          companyName={company.name}
          slug={company.slug}
        />
      );
    if (!isManager(company)) return <NoAccessPage what="KPI reporting" slug={company.slug} />;
    return (
      <KpiReportingScreen
        api={api}
        company={company}
        seatId={seat}
        onSeat={(id) =>
          void navigate({
            to: ".",
            search: (prev: Record<string, unknown>) => ({ ...prev, seat: id }),
          } as never)
        }
      />
    );
  },
});
